import { createReducer, on } from '@ngrx/store';
import {
  LoadReferralAccountSettingsRequested,
  LoadReferralAccountSettingsSuccess,
  LoadReferralAccountSettingsFailure,
  UpdateReferralAccountSettingsRequested,
  UpdateReferralAccountSettingsSuccess,
  UpdateReferralAccountSettingsFailure,
} from './referral-account-settings.actions';
import { ReferralUser } from '@app/core/interfaces/user.interface';
import { SaveResult } from '@app/shared/interfaces/saveResult.interface';

export const referralAccountSettingsFeatureKey = 'referralAccountSettings';

export interface State {
  loading: boolean;
  error: any;
  user: ReferralUser | null;
  lastSaveResult: SaveResult | null;
}

export const initialState: State = {
  loading: false,
  error: null,
  user: null,
  lastSaveResult: null,
};

export const reducer = createReducer(
  initialState,
  on(LoadReferralAccountSettingsRequested, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(LoadReferralAccountSettingsSuccess, (state, { user }) => ({
    ...state,
    loading: false,
    user,
  })),
  on(LoadReferralAccountSettingsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(UpdateReferralAccountSettingsRequested, (state) => ({
    ...state,
    loading: true,
    error: null,
    lastSaveResult: null,
  })),

  on(UpdateReferralAccountSettingsSuccess, (state, { result }) => ({
    ...state,
    loading: false,
    lastSaveResult: result,
  })),

  on(UpdateReferralAccountSettingsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
